import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { ArrowSwapButton, Box, Stack } from '@esgian/esgianui';
import { PortSelect } from '@components/Inputs';
import { useLookupActiveLocations } from '@hooks/useDynamicLookupQueries/useLookupActiveLocations';
import { GEOGRAPHICAL_TYPES } from '@constants';

function SelectPortLoadAndDischarge({
  selectedPortDischarge,
  selectedPortLoad,
  setSelectedPortLoad,
  setSelectedPortDischarge,
  handleSwap,
  dischargeLabel,
  loadLabel
}) {
  const { data: lookupActiveLocations } = useLookupActiveLocations();

  const handlePortSwap = () => {
    let tempLoad = selectedPortLoad ? { ...selectedPortLoad } : null;
    let tempDist = selectedPortDischarge ? { ...selectedPortDischarge } : null;
    if (handleSwap) {
      handleSwap(tempDist, tempLoad);
    } else {
      setSelectedPortLoad(tempDist);
      setSelectedPortDischarge(tempLoad);
    }
  };
  const comparePort = (a, b) => a.portName.localeCompare(b.portName);
  const lookupPorts = useMemo(() => {
    if (!lookupActiveLocations.length) return [];
    let res = [];
    lookupActiveLocations.forEach((item) => {
      if (item.geoType === GEOGRAPHICAL_TYPES.PORT) {
        const match = item.displayName.match(/^(.*?)\s*\((.*?)\)$/);
        res.push({ portName: match[1], id: item.geoId, unlocode: match[2], active: true });
      }
    });
    return res.sort(comparePort);
  }, [lookupActiveLocations]);
  return (
    <Stack direction={'row'}>
      <Stack className={'section-filter'}>
        <PortSelect
          label={loadLabel}
          id={'port-select-load'}
          getOptionDisabled={(option) => option.id === selectedPortDischarge?.id}
          placeholder={'Select load port...'}
          selectedPort={selectedPortLoad}
          handleChange={setSelectedPortLoad}
          portList={lookupPorts}
        />
      </Stack>
      <Box alignSelf={'flex-end'} sx={{ pb: 1 }}>
        <ArrowSwapButton handleClick={handlePortSwap} color={'inherit'} />
      </Box>
      <Stack className={'section-filter'}>
        <PortSelect
          label={dischargeLabel}
          id={'port-select-discharge'}
          getOptionDisabled={(option) => option.id === selectedPortLoad?.id}
          placeholder={'Select discharge port...'}
          selectedPort={selectedPortDischarge}
          handleChange={setSelectedPortDischarge}
          portList={lookupPorts}
        />
      </Stack>
    </Stack>
  );
}

SelectPortLoadAndDischarge.propTypes = {
  selectedPortDischarge: PropTypes.object,
  dischargeLabel: PropTypes.string,
  loadLabel: PropTypes.string,
  selectedPortLoad: PropTypes.object,
  setSelectedPortLoad: PropTypes.func.isRequired,
  setSelectedPortDischarge: PropTypes.func.isRequired,
  handleSwap: PropTypes.func
};

SelectPortLoadAndDischarge.defaultProps = {
  selectedPortDischarge: null,
  dischargeLabel: 'Port of Discharge*',
  loadLabel: 'Port of Load*',
  handleSwap: null
};

export default SelectPortLoadAndDischarge;
